// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiftref-checkbox-label {
    margin-bottom: var(--spacing-10);
    height: 20px;
    display: flex;
    align-items: center;
    color: var(--text-default);
    /*flex-direction: row-reverse;*/
    width: max-content;
    font-family: var(--font-family);
    font-weight: var(--p1-regular-font-weight);
    gap: var(--spacing-10);
    /*position: relative;*/
    user-select: none;
    /*margin-bottom: var(--spacing-10);*/
}
:host([disabled]) .swiftref-checkbox-label {
    color: var(--text-disabled);
}

/*custom checkbox see https://developer.mozilla.org/en-US/docs/Learn/Forms/Advanced_form_styling*/
.swiftref-checkbox {
    height: var(--spacing-20);
    width: var(--spacing-20);
    min-width: var(--spacing-20);
    margin: 0;
    padding: 0;
    appearance: none;
    outline: var(--border-weight-default) solid var(--border-strong);
    position: relative;
}
.swiftref-checkbox:not(:disabled) {
    cursor: pointer;
}

.swiftref-checkbox::before {
    /*font-size: 1.2em;*/
    /*right: 0;*/
    /*top: 0;*/
    visibility: hidden;
}
.swiftref-checkbox:checked::after {
    content: "";
    position: absolute;
    left: 9px;
    top: 4px;
    width: 2px;
    height: 8px;
    transform: rotate(45deg);
    background: var(--accent-strong-selected);
}
.swiftref-checkbox:checked::before {
    content: "";
    position: absolute;
    left: 5px;
    top: 7px;
    width: 2px;
    height: 5px;
    transform: rotate(-45deg);
    background: var(--accent-strong-selected);
}
.swiftref-checkbox:indeterminate::before {
    content: "";
    position: absolute;
    top: 4px;
    left: 4px;
    width: 8px;
    height: 8px;
    background: var(--accent-strong-selected);
}

.swiftref-checkbox:checked,
.swiftref-checkbox:indeterminate {
    background: var(--accent-light-selected);
}

.swiftref-checkbox:hover  {
    background: var(--accent-light-hover);
}
.swiftref-checkbox:focus  {
    /*style guides says 2px*/
    /*important needed for bwo*/
    outline: var(--border-weight-default) solid var(--border-focused) !important;
}
.swiftref-checkbox:disabled  {
    background: var(--background-disabled);
}



.swiftref-checkbox:checked:disabled::after,
.swiftref-checkbox:checked:disabled::before,
.swiftref-checkbox:indeterminate:disabled::before {
    background: var(--icon-disabled);
}

.swiftref-checkbox:checked::before,
.swiftref-checkbox:indeterminate::before{
    visibility: unset;
    color: var(--accent-strong-selected);
}
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/checkbox/style/index.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,+BAA+B;IAC/B,kBAAkB;IAClB,+BAA+B;IAC/B,0CAA0C;IAC1C,sBAAsB;IACtB,sBAAsB;IACtB,iBAAiB;IACjB,oCAAoC;AACxC;AACA;IACI,2BAA2B;AAC/B;;AAEA,iGAAiG;AACjG;IACI,yBAAyB;IACzB,wBAAwB;IACxB,4BAA4B;IAC5B,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,gEAAgE;IAChE,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,wBAAwB;IACxB,yCAAyC;AAC7C;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,yCAAyC;AAC7C;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,yCAAyC;AAC7C;;AAEA;;IAEI,wCAAwC;AAC5C;;AAEA;IACI,qCAAqC;AACzC;AACA;IACI,wBAAwB;IACxB,2BAA2B;IAC3B,4EAA4E;AAChF;AACA;IACI,sCAAsC;AAC1C;;;;AAIA;;;IAGI,gCAAgC;AACpC;;AAEA;;IAEI,iBAAiB;IACjB,oCAAoC;AACxC","sourcesContent":[".swiftref-checkbox-label {\n    margin-bottom: var(--spacing-10);\n    height: 20px;\n    display: flex;\n    align-items: center;\n    color: var(--text-default);\n    /*flex-direction: row-reverse;*/\n    width: max-content;\n    font-family: var(--font-family);\n    font-weight: var(--p1-regular-font-weight);\n    gap: var(--spacing-10);\n    /*position: relative;*/\n    user-select: none;\n    /*margin-bottom: var(--spacing-10);*/\n}\n:host([disabled]) .swiftref-checkbox-label {\n    color: var(--text-disabled);\n}\n\n/*custom checkbox see https://developer.mozilla.org/en-US/docs/Learn/Forms/Advanced_form_styling*/\n.swiftref-checkbox {\n    height: var(--spacing-20);\n    width: var(--spacing-20);\n    min-width: var(--spacing-20);\n    margin: 0;\n    padding: 0;\n    appearance: none;\n    outline: var(--border-weight-default) solid var(--border-strong);\n    position: relative;\n}\n.swiftref-checkbox:not(:disabled) {\n    cursor: pointer;\n}\n\n.swiftref-checkbox::before {\n    /*font-size: 1.2em;*/\n    /*right: 0;*/\n    /*top: 0;*/\n    visibility: hidden;\n}\n.swiftref-checkbox:checked::after {\n    content: \"\";\n    position: absolute;\n    left: 9px;\n    top: 4px;\n    width: 2px;\n    height: 8px;\n    transform: rotate(45deg);\n    background: var(--accent-strong-selected);\n}\n.swiftref-checkbox:checked::before {\n    content: \"\";\n    position: absolute;\n    left: 5px;\n    top: 7px;\n    width: 2px;\n    height: 5px;\n    transform: rotate(-45deg);\n    background: var(--accent-strong-selected);\n}\n.swiftref-checkbox:indeterminate::before {\n    content: \"\";\n    position: absolute;\n    top: 4px;\n    left: 4px;\n    width: 8px;\n    height: 8px;\n    background: var(--accent-strong-selected);\n}\n\n.swiftref-checkbox:checked,\n.swiftref-checkbox:indeterminate {\n    background: var(--accent-light-selected);\n}\n\n.swiftref-checkbox:hover  {\n    background: var(--accent-light-hover);\n}\n.swiftref-checkbox:focus  {\n    /*style guides says 2px*/\n    /*important needed for bwo*/\n    outline: var(--border-weight-default) solid var(--border-focused) !important;\n}\n.swiftref-checkbox:disabled  {\n    background: var(--background-disabled);\n}\n\n\n\n.swiftref-checkbox:checked:disabled::after,\n.swiftref-checkbox:checked:disabled::before,\n.swiftref-checkbox:indeterminate:disabled::before {\n    background: var(--icon-disabled);\n}\n\n.swiftref-checkbox:checked::before,\n.swiftref-checkbox:indeterminate::before{\n    visibility: unset;\n    color: var(--accent-strong-selected);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
